import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar'

const Loader = (props) => {
    return (
        <ProgressBar style={{marginTop: '57px'}} animated now={100} />
    )
}

export default Loader